module.exports = __webpack_public_path__ + "assets/img/left_3.8b0a524b.png";